export default "__VITE_ASSET__2113d800__"